import { render } from "./Star.vue?vue&type=template&id=3c1d208a"
import script from "./Star.vue?vue&type=script&lang=js"
export * from "./Star.vue?vue&type=script&lang=js"

import "./Star.vue?vue&type=style&index=0&id=3c1d208a&lang=scss"

import exportComponent from "E:\\coding\\desktop\\namya-poll\\namya-poll\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__